import { Tooltip } from "@mui/material";
import React from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { Close } from "@mui/icons-material";

//Styles
import { withStyles } from "tss-react/mui";
import Button from "../../../../../components/CustomButtons/Button";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";
import Table from "../../../../../components/Table/Table";
import OverzichtStyle from "../../Customfields/Components/OverzichtStyle";

function Overzicht({ ...props }) {
  const { classes } = props;

  const convertTableData = () => {
    let output = [];

    if (!(props.customFields === null || props.customFields === "")) {
      try {
        const customFields = JSON.parse(props.customFields);

        output = customFields.map((prop) => {
          const simpleButtons = [
            {
              color: "danger",
              icon: Close,
              tooltip: <TranslationWrapper tDefault={"Verwijderen"} tKey={"global.button.verwijderen"} />,
              click: () => props.onDelete(prop, "extra_settings__paymentApiIds"),
            },
          ].map((buttonProp, key) => {
            return (
              <Tooltip classes={{ tooltip: classes.tooltip }} key={key} placement={"bottom"} title={buttonProp.tooltip}>
                <Button
                  className={classes.actionButton}
                  color={buttonProp.color}
                  disabled={props.disableAll}
                  justIcon
                  onClick={buttonProp.click}
                  simple
                >
                  <buttonProp.icon className={classes.icon} />
                </Button>
              </Tooltip>
            );
          });

          return [prop.method, prop.name, prop.code, simpleButtons];
        });
      } catch (e) {}
    }

    return output;
  };

  return (
    <GridContainer>
      <GridItem lg={12} md={12} xs={12}>
        <Table
          customCellClasses={[classes.right]}
          customClassesForCells={[7]}
          customHeadCellClasses={[classes.right]}
          customHeadClassesForCells={[7]}
          tableData={convertTableData()}
          tableHead={[
            <TranslationWrapper
              tDefault={"Method"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.method"}
            />,
            <TranslationWrapper
              tDefault={"Description"}
              tKey={"vestigingen.form.customfields.overzicht.table.head.descr"}
            />,
            <TranslationWrapper tDefault={"Code"} tKey={"vestigingen.form.customfields.overzicht.table.head.code"} />,
          ]}
        />
      </GridItem>
    </GridContainer>
  );
}

export default withStyles(Overzicht, OverzichtStyle);
